import React, { useEffect, useRef, useState } from 'react';
import { View, Text, Image, StyleSheet, Platform, StatusBar, TouchableOpacity,  FlatList,  ActivityIndicator } from 'react-native';
import Btn from "../components/btn"
import INPU from "../components/input"
import Colors from '../constants/Colors';
import { Ionicons } from "@expo/vector-icons"
import { Modal, NativeBaseProvider } from 'native-base';
import { getDetailsMdfColor, getMdfColor, SetMDFlist } from '../store/action/userProduct';
import { useDispatch, useSelector } from 'react-redux';
import AwesomeAlert from 'react-native-awesome-alerts';
import { logOut } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';










const Searching = (props) => {
    // const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();


    const [Loading, setloading] = useState(false)
    const [Wallet, setWallet] = useState(false)
    const [State, setState] = useState({
        isLoading: false,
        isLoading1: false,
        showModal: false,
       


    });


    const [Offset, setOffset] = useState(1);

    const [name, setname] = useState("");
    const [dataSource, setDataSource] = useState([]);
    const [MdfDetails, setMdfDetails] = useState([]);
    const [MdfDetailstitle, setMdfDetailstitle] = useState("");
    const resetData = useRef(false);





    const getMDFHandler = async () => {

        try {

            let pageToReq = Offset;
            if (resetData.current) {
                pageToReq = 0;
            }


            setState({ ...State, isLoading: true })
            const res = await dispatch(getMdfColor(tokens,
                Offset,
                name
            ));

            if (resetData.current) {
                setDataSource(res.data.data.products.data);
                resetData.current = false;
            } else {
                setDataSource([...dataSource, ...res.data.data.products.data])
            }








         
            setState({ ...State, isLoading: false })


        } catch (err) {
            console.log(err);
        }
    };


    useEffect(() => {
        getMDFHandler()

    }, [Offset, name]);



    const handleOnChangeText = (val) => {
        if (!val) {
            setOffset(1)
        }
        resetData.current = true;
        setname(val);
    };


    const handleOnEnd = () => {
        if (resetData.current) {
            return;
        }
        setOffset(Offset + 1);
    };



    const renderFooter = () => {
        return (
            //Footer View with Load More button
            <View style={styles.footer}>
                <TouchableOpacity
                    activeOpacity={0.9}
                    onPress={getMDFHandler}
                    //On Click of button calling getData function to load more data
                    style={styles.loadMoreBtn}>
                    <Text style={styles.btnText}> بیشتر </Text>
                    {State.isLoading ? (
                        <ActivityIndicator color="white" style={{ marginLeft: 8 }} />
                    ) : null}
                </TouchableOpacity>
            </View>
        );
    };




    const getMDFDtailsHandler = async (id) => {
        try {
            setloading(true)
            const res = await dispatch(getDetailsMdfColor(tokens, id));

            setMdfDetails(res.data.data.product.options)
            setMdfDetailstitle(res.data.data.product)

            //console.log(res.data.data.product);
            setloading(false)


        } catch (err) {
            // logOutHandler();
        }
    };






    const setMDFHandler = async () => {
        try {
            setState({ ...State, isLoading1: true })
            const res = await SetMDFlist(tokens, MdfDetailstitle.code);
            //console.log(res);


            if (res.status == "success") {
                setWallet(true)
            


            }
            setState({ ...State, isLoading1: false })
        } catch (err) {
            console.log(err);
        }
    };




    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };




    



    return (

        <NativeBaseProvider>
          
         
            <View style={styles.viewContainer}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.background} />

                    <Btn
                        label="بستن"
                        nameicon="close"
                        sizeicon={15}
                        styleicon={{ position: "absolute", left: 15, top: 3, }}
                        coloricon={Colors.background}
                        style={{ width: "25%", marginLeft: "5%", marginTop: 40, }}
                        textStyle={{ bottom: 4, right: 10, marginRight: 10 }}
                        onPress={() => props.navigation.goBack()}
                    />

                    <INPU

                        label="جستجو"

                        styleview={{ width: "70%", marginTop: 40, right: Platform.OS === "web" ? "3%" : "8%" }}
                        stylelabel={{ width: "22%", }}
                        styleinput={{ height: 45 }}
                        keyboardType="default"
                        //onKeyPress={getMDFHandler}
                        // value={name}
                        onChangeText={handleOnChangeText}

                    //styleinput={Platform.OS === "web" && {outlineColor:Colors.blue }}
                    />

                </View>

                <Modal justifyContent="center" size="xl"
                    isOpen={State.showModal} onClose={() => setState({ ...State, showModal: false })}>
                    <Modal.Content style={{ borderRadius: 30 }}>
                        <Modal.Body >


                            {Loading ?


                                <View style={{ width: "100%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: Colors.background }} >
                                    <ActivityIndicator
                                        animating={Loading} size={30} color={Colors.primary} />

                                    <Text style={{ fontFamily: "MontserratBold", fontSize: 25, color: Colors.primary, marginTop: 30 }}>لطفا شکیبا باشید...</Text>
                                </View>

                                :



                                <View style={{ width: "100%", alignSelf: "auto" }}>

                                    <View style={{ width: "100%", height: 50, }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 16, color: Colors.black, position: "absolute", right: "1%", top: "5%" }}>{MdfDetailstitle.title}</Text>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.secondText3, position: "absolute", right: "1%", top: "60%" }}>کد محصول : {MdfDetailstitle.code}</Text>
                                        <Ionicons onPress={() => setState({ ...State, showModal: false })} name="close" size={25} color={Colors.black} />
                                    </View>
                                    <View style={{ width: "100%", height: 150, marginTop: "2%", marginBottom: "2%", }}>
                                        <Image source={{ uri: MdfDetailstitle.thumb ? MdfDetailstitle.thumb : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOVLVPLsjgkzqnuf8I9HWsn675o_uSnDF8uw&usqp=CAU" }} style={{ width: "100%", height: 150, }} />
                                    </View>

                                    {MdfDetails.map((item, i) => {
                                        return (

                                            <View key={i} style={{ width: "100%", marginTop: "2%", marginBottom: 3 }}>
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.black }}>{item.option ? item.option.title : "-"} : <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.secondText3, position: "absolute", right: "1%", top: "50%" }}>{item.value ? item.value : "-"}</Text> </Text>
                                            </View>



                                        )
                                    })}







                                </View>
                            }

                            <View style={{ width: "100%", alignSelf: "auto", backgroundColor: Colors.background, justifyContent: "center", marginTop: 30, marginBottom: 30 }}>


                                <Btn
                                    touchableStyle={{
                                        width: "90%",
                                        height: 50,
                                        backgroundColor: Colors.yellowdark,
                                    }}
                                    textStyle={{ bottom: 10, fontSize: 16 }}
                                    style={{ position: "absolute", left: Platform.OS == "web" ? "2%" : "5%", }}
                                    onPress={() => {
                                        setMDFHandler()
                                        //props.navigation.navigate("ordercolor")

                                    }}
                                    colorspin={Colors.background}
                                    sizespin={25}
                                    loading={State.isLoading1}
                                    label="افزودن به لیست"

                                />

                                {/* <Btn
                                       touchableStyle={{
                                           width: "40%",
                                           height: 50,
                                           backgroundColor: Colors.primary,
                                       }}
                                       textStyle={{ bottom: 10, fontSize: 16 }}
                                       style={{ position: "absolute", left: "55%", marginTop: 20, bottom: 10 }}
                                       onPress={() => props.navigation.navigate("form",{
                                           image:"" 
                                        })}
                                       colorspin={Colors.background}
                                       sizespin={25}
                                       label="تایید و ادامه"
                   
                                   /> */}


                                {/* <Btn
                                                           touchableStyle={{
                                                               width: "86%",
                                                               height: 50,
                                                               backgroundColor: Colors.blue,
                                                           }}
                                                           textStyle={{ bottom: 10, fontSize: 16 }}
                                                           style={{ position: "absolute", marginLeft: 23, marginTop: 20, bottom: 10 }}
                                                           onPress={() => props.navigation.navigate("form", {
                                                               image: images
                                                           })}
                                                           colorspin={Colors.background}
                                                           sizespin={25}
                                                           label="تاییدو ادامه"
                   
                                                       /> */}
                            </View>

                        </Modal.Body>

                    </Modal.Content>
                </Modal>










                <FlatList

                    data={dataSource}
                    onEndReachedThreshold={0.5}
                    onEndReached={handleOnEnd}
                    ListFooterComponent={renderFooter}
                    enableEmptySections={true}
                    renderItem={({ item, index }) =>

                        <View key={index} style={{ width: "100%", height: 70, marginTop: 10, }}>

                            <TouchableOpacity onPress={() => {
                                setState({ ...State, showModal: true })
                                getMDFDtailsHandler(item.id)
                            }} style={{ borderRadius: 5, flexDirection: "row", width: "91%", height: 70, backgroundColor: Colors.background1, left: Platform.OS === "web" ? "4%" : "27%", borderRadius: 10, borderWidth: 1, borderColor: Colors.secondText3 }}>
                                <View style={{ borderRadius: 5, width: "80%", height: 70, }}>
                                    <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, position: "absolute", right: "3%", top: "15%" }}>{item.title}</Text>
                                    <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.black, position: "absolute", right: "3%", top: "50%" }}>کد محصول : {item.code}</Text>
                                </View>
                                <View style={{ borderRadius: 5, width: "20%", height: 70, }}>
                                    <Image source={{ uri: item.thumb ? item.thumb : "https://dasterang.ir/image/product/1587197829lteqSKMkNGsgkoEfBh8FUiF8pXBJUKpRgmIv6dGOIaxkkvVGfm.jpeg" }} alt="image" style={{ width: "90%", height: 60, marginTop: 5, borderRadius: 5 }} />
                                </View>
                            </TouchableOpacity>
                        </View>




                    }
                    keyExtractor={(item, index) => index.toString()}

                />
  <AwesomeAlert
                show={Wallet}
                showProgress={false}
                title="موفق"
                message="تکه با موفقیت افزوده شد"
                closeOnTouchOutside={false}
                closeOnHardwareBackPress={false}
                // showCancelButton={true}
                showConfirmButton={true}
                // cancelText="باشه"
                confirmText="باشه"
                confirmButtonColor={Colors.success}
                // onCancelPressed={() => {
                //   setShow(false);
                // }}
                onConfirmPressed={() => {
                    setWallet(false);
                    setTimeout(() => {
                        props.navigation.navigate("ordercolor")
                    }, 1000);
                    //props.navigation.navigate("home")
                }}
                titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: Colors.success }}
                messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
            />


            </View>
        </NativeBaseProvider>

    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background2,
        position:Platform.OS=="web"?"fixed":"relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: 90,
        backgroundColor: Colors.background,
    },
    text: {
        fontFamily: "Montserrat",
        fontSize: 14,
        color: Colors.secondText3,
        textAlign: "right",
        marginTop: 30,
    },


    footer: {
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
    },
    loadMoreBtn: {
        padding: 10,
        backgroundColor: Colors.primary,
        borderRadius: 4,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    btnText: {
        color: Colors.background,
        fontSize: 15,
        textAlign: 'center',
        fontFamily: "MontserratBold",
    },
})




export default Searching

